import { defineStore } from 'pinia'
import { permissionApi } from '@/api'

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    roles: [],        // 用户角色列表
    permissions: [],  // 用户权限列表
    menus: [],        // 用户可见菜单树
    loaded: false     // 是否已加载权限数据
  }),

  getters: {
    // 检查是否有某个权限
    hasPermission: (state) => (permission) => {
      return state.permissions.includes(permission)
    },

    // 检查是否有某个角色
    hasRole: (state) => (role) => {
      return state.roles.includes(role)
    },

    // 检查是否已加载权限
    isLoaded: (state) => state.loaded
  },

  actions: {
    // 加载用户权限数据
    async loadUserPermissions() {
      try {
        const result = await permissionApi.getUserPermissions()

        if (result.code === '0' && result.data) {
          this.roles = result.data.roles || []
          this.permissions = result.data.permissions || []
          this.menus = result.data.menus || []
          this.loaded = true

          return result.data
        } else {
          throw new Error(result.msg || '获取权限失败')
        }
      } catch (error) {
        console.error('加载用户权限失败:', error)
        throw error
      }
    },

    // 重置权限数据
    resetPermissions() {
      this.roles = []
      this.permissions = []
      this.menus = []
      this.loaded = false
    }
  }
})
